/* @flow */

import graficoDeColunas from '../utils/grafico-de-colunas';

type Data = {
    horaFormatada: string,
    quantidade: number,
};

const gerarGraficoPorHoras = (horas: Data[]) => {
    graficoDeColunas({
        resultado: horas.map(dia => [`${dia.horaFormatada}h`, dia.quantidade]),
        id: 'grafico-horas',
        coluna: ['Horas', 'Quantidade'],
    });
};

export default gerarGraficoPorHoras;
